module.exports = __webpack_public_path__ + "static/media/narfi.7a229e99.svg";